module.exports = __webpack_public_path__ + "img/service-content-data@3x.3ba8d86f.png";